import { useEffect, useMemo, useState } from 'react';

// Dev-Login-Quicklinks (wie Klaus' Login-Seite mit KLAUS_DEV_AUTH=1): ein Klick
// meldet lokal als beliebiger User an. Der Server liefert die Liste nur mit
// DIETER_DEV_AUTH=1 außerhalb von Produktion (restapi/v1/devLogin.ts) —
// sonst 404, und hier erscheint nichts.

interface DevLoginUser {
  email: string;
  role: string;
  mfa: boolean;
  company: string | null;
  plan: string | null;
  activated: boolean;
  whitelabel: boolean;
  klausSeen: boolean;
}

function devLoginHref(email: string, next?: string) {
  const params = new URLSearchParams({ email });
  if (next) params.set('next', next);
  return `/api/dev/login?${params}`;
}

export function DevLoginLinks() {
  const [users, setUsers] = useState<DevLoginUser[] | null>(null);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    let active = true;
    fetch('/api/dev/login/users', { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => active && Array.isArray(data) && setUsers(data))
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, []);

  const shown = useMemo(() => {
    const q = filter.trim().toLowerCase();
    if (!users) return [];
    return q ? users.filter((u) => `${u.email} ${u.company ?? ''} ${u.role}`.toLowerCase().includes(q)) : users;
  }, [users, filter]);

  if (!users?.length) return null;

  return (
    <div
      className="mt-6 w-full max-w-xl rounded-lg border border-dashed border-gray-300 bg-white/70 p-4 text-sm"
      data-testid="dev-login-links"
    >
      <div className="mb-2 flex items-center justify-between gap-3">
        <strong>Dev-Login (DIETER_DEV_AUTH=1)</strong>
        <input
          className="rounded border border-gray-300 px-2 py-1 text-sm"
          placeholder="Filtern …"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
      </div>
      <ul className="max-h-80 overflow-y-auto">
        {shown.map((u) => (
          <li key={u.email} className="flex items-baseline justify-between gap-3 border-t border-gray-100 py-1.5">
            <a href={devLoginHref(u.email)} className="min-w-0 truncate" title="Als dieser User ins Dashboard">
              → <span className="font-medium">{u.email}</span>{' '}
              <span className="text-gray-500">
                · {u.role}
                {u.company ? ` · ${u.company}` : ''}
                {u.plan ? ` · ${u.plan}${u.activated ? '' : ' (inaktiv)'}` : ' · Freemium'}
                {u.whitelabel ? ' · Whitelabel' : ''}
                {u.mfa ? ' · MFA' : ''}
                {u.klausSeen ? ' · hat Klaus' : ''}
              </span>
            </a>
            <a
              href={devLoginHref(u.email, '/zu-klaus')}
              className="shrink-0 whitespace-nowrap"
              title="Anmelden und direkt per Sprungmarke zu Klaus"
            >
              → Klaus
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
